'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'Select time'
};

exports['default'] = locale;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.8@ant-design-vue/lib/time-picker/locale/en_US.js
// module id = q71v
// module chunks = 16